import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-descuento-edit',
  templateUrl: './descuento-edit.component.html',
  styleUrls: ['./descuento-edit.component.css']
})
export class DescuentoEditComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  resultado:any=[];
  tiempoMsg:number=3200;
  activo:boolean;
  esNuevo:boolean;
  esDuplicado:boolean = false;
  thisForm = new FormGroup({
    descuento: new FormControl(this.data.item.descuento, [Validators.required, Validators.minLength(3)]),
    valor: new FormControl(this.data.item.valor, [Validators.required, Validators.minLength(1)]),
  });

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<DescuentoEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    console.log(this.data);
    if(this.data){
      if(this.data.id > 0)
        this.esNuevo=false;
      else
        this.esNuevo=true;
    }
    this.activo = this.data.item.act
  }

  fnKeyPress(t, e){
    this.errMsg="";
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  onBlur(event){
    this.dataService.isDescuentoDup(this.thisForm.controls["descuento"].value).subscribe(
                          rows => {   
                                  this.resultado = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnDescuentoDuplicado());
  }

  fnDescuentoDuplicado(){
    this.esDuplicado = false;
    if(this.resultado > 0){
      this.fnMuestraMensaje("ERR", "El descuento ya ha sido dado de alta; elija otro o edite el existente.", false, false);
      this.thisForm.controls["descuento"].markAsDirty();
      var aux = <HTMLInputElement>document.getElementById("txtDescuento");
      this.esDuplicado=true;
      aux.focus();
    }
  }

  fnMuestraMensaje(tipo:string, msg:string, changeLoading:boolean, closeDialog:boolean){
    this.okMsg = "";
    this.errMsg = "";
    if(tipo=="OK")
      this.okMsg = msg;
    if(tipo=="ERR")
      this.errMsg = msg;
    setTimeout(() => {
      this.okMsg = "";
      this.errMsg = "";
      if(changeLoading)
        this.loading = !this.loading;
      if(closeDialog)
        this.dialogRef.close();
    }, this.tiempoMsg);
  }

  fnDesactivar(){
    this.activo = false;
  }

  fnActivar(){
    this.activo = true;
  }

  fnGuardar(){
    this.loading = true;
    if(this.esNuevo){
      //console.log("GUARDAR");
      //--> Descuento con nombre, mínimo 3 caracteres, asignación de valor (porcentaje):
      if(this.thisForm.valid)
        this.dataService.insDescuento(this.thisForm.controls["descuento"].value, this.activo, null, '%',  this.thisForm.controls["valor"].value).subscribe(
                        rows => {   
                                this.resultado = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnDescuentoGuardado());           
      else{
        //console.log(this.thisForm.controls["forma"].errors);
        if(this.thisForm.controls["descuento"].errors){
          if(this.thisForm.controls["descuento"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture un nombre de 'descuento'.", true, false)
          if(this.thisForm.controls["descuento"].errors.minlength){
            if(this.thisForm.controls["descuento"].errors.minlength.actualLength < this.thisForm.controls["descuento"].errors.minlength.requiredLength)
            this.fnMuestraMensaje("ERR", "El nombre de 'descuento' debe contener " + this.thisForm.controls["descuento"].errors.minlength.requiredLength + " o más caracteres.", true, false)
          }
          return;
        }
        if(this.thisForm.controls["valor"].errors){
          if(this.thisForm.controls["valor"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture el 'porcentaje' del descuento.", true, false);
          return;
        }
      }
    }
    else{
      //console.log("EDITAR");
      //--> Asignación de valor (porcentaje):
      if(this.thisForm.valid)
      this.dataService.updDescuento(this.data.id, this.activo, null, '%', this.thisForm.controls["valor"].value).subscribe(
                      rows => {   
                              this.resultado = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnDescuentoEditado());    
     
      else{
        if(this.thisForm.controls["valor"].errors){
          if(this.thisForm.controls["valor"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture el 'porcentaje' del descuento.", true, false);
          return;
        }
      }
    }
  }

  fnDescuentoGuardado(){
    //console.log(this.resultado);
    if(this.resultado == 1){
      this.fnMuestraMensaje("OK", "Registro almacenado", false, true);
    }
    else{
      this.fnMuestraMensaje("ERR", "Error al almacenar registro", true, false);
      setTimeout(() => {
        this.loading = false;
      }, this.tiempoMsg);
    }
  }  

  fnDescuentoEditado(){
        //console.log(this.resultado);
        if(this.resultado == 1){
          this.okMsg = "Registro actualizado"
          setTimeout(() => {
            this.okMsg = "";
            this.loading = false;
            this.dialogRef.close();
          }, this.tiempoMsg);
        }
        else{
          this.errMsg = "Error al actualizar registro!"
          setTimeout(() => {
            this.errMsg = "";
            this.loading = false;
            console.log("LOADING:" + this.loading);
          }, this.tiempoMsg);
        }    
  }

}
